import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setUsers = users => {
	return {
		type: ActionTypes.LOAD_USERS,
		users: users.data
	};
};

export const loadUsers = token => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);

		axios
			.get(
				"http://190.105.227.203/solanasapi/usuario/",
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				if (response != undefined) dispatch(setUsers(response.data));
			})
			.catch(error => {});
	};
};
